import { Translation } from 'locales/de/pages/Events/events';

const en: Translation = {
  title: 'Events',
  detailTitle: 'Event',
  registration: 'Registration',
  waitingListLength: 'Waitinglistlength',
  eventTimeSpan: 'Takes place on following period:',
  eventDate: 'Date:',
  startDate: 'Startdate',
  endDate: 'Enddate',
  cancelled: 'Cancelled',
  moveToGroup: 'Move to group',
  ended: 'Ended',
  notSpecified: 'Not specified',
  addParticipant: 'Add participant',
  preCalculated:
    'The pre calculated list of participants is currently displayed. The list of participants may change until the end of registration.',
  groupWithoutInfo: 'Group without info',
  create: {
    steps: {
      organization: 'Organization',
      informations: 'Informations',
      groups: 'Groups',
      preview: 'Preview'
    },
    title: 'New Event',
    editTitle: 'Edit event',
    eventName: 'Title',
    description: 'Description',
    date: 'Date',
    authorRole: 'Autorenrolle',
    host: 'Host',
    lecturer: 'Lecturer',
    organizer: 'Editor roles',
    organizingPersons: 'Further editors',
    organizingPersonsPlaceholder: 'Please enter email',
    occupancy: 'Occupancy',
    waitingList: 'Waitinglist',
    partListVisible: 'Participantlist visible',
    isUnenrollAfterRegPeriodPossible: 'Unenroll after end of registration period',
    visibleFrom: 'Visible from',
    regPeriodEnd: 'End of registration period',
    regPeriodStart: 'Start of registration period',
    startDate: 'Start of the event',
    endDate: 'End of the event',
    attachment: 'Attachment',
    calendarInviteTitle: 'Calendar invitation',
    calendarInviteText: 'Send an invitation to the calendar for this event?',
    attachmentPlaceholder: 'Upload attachment',
    waitingListTypes: {
      NONE: 'No Waitinglist',
      GROUP: 'Every group has its own waitinglist',
      EVENT: 'One waitinglist for the whole event'
    },
    priorization: 'Prioritization',
    priorizationType: {
      SEMESTER: 'Prioritize semester in descending order',
      DATE: 'Prioritize earliest registrations'
    },
    groupManagement: 'Group management',
    sameGroupSize: 'Consistent group size',
    maxParticipants: 'Maximum number of participants',
    minParticipants: 'Minimum number of participants',
    addNewGroupButton: 'Add new group',
    groupCard: {
      group: 'Group',
      place: 'Place',
      info: 'Info',
      date: 'Date',
      maxParticipants: 'Maximum number of participants',
      minParticipants: 'Minimum number of participants',
      participants: 'Participants',
      currently: 'Currently',
      currentlyPreCalc: 'Currently (provisionally)',
      min: 'Minimum',
      max: 'Maximum',
      peopleInWaitinglist: 'People in waitinglist',
      peopleInWaitinglistPreCalc: 'People in waitinglist (provisionally)'
    },
    maxParticipantIncreasePromotionInfo:
      'The maximum number of participants has been increased.\n People from the waiting list will move up.'
  },
  cancelModal: {
    headline: 'Cancellation of the group:',
    howToCancel: 'How should the group be cancelled?',
    complete: 'Complete',
    automatic: 'Participants are distributed automatically',
    manually: 'Participants are manually distributed'
  },
  filter: {
    occupancy: 'Filter by occupancy',
    host: 'Host',
    enrolled: 'Participating',
    onWaitingList: 'incl. on waitinglist',
    showAll: 'All Events',
    showAllMobile: 'All',
    myEvents: 'My Events',
    myEventsMobile: 'Mine'
  },
  tooltips: {
    mail: 'Mailing',
    createEventArticle: 'Article-Link',
    participantListVisible: 'If selected the participantlist is visible for all participants',
    isUnenrollAfterRegPeriodPossible:
      'If this is activated, participants can still unenroll themselves from the event after the registration period ends. No persons will automatically move up from the waiting list.',
    attachments: 'Attachments',
    enroll: 'Enroll to event',
    unenroll: 'Unenroll from event',
    refresh: 'Refresh',
    exports: 'File exports',
    edit: 'Edit event',
    copy: 'Copy event',
    delete: 'Delete event',
    cancel: 'Cancel event',
    showAll: 'All events including past and cancelled Events',
    myEvents: 'All events that you are allowed to edit',
    occupancy: 'The percentage of participants',
    waitingList:
      'If prioritization is for semesters, a waitinglist has to be picked since the distribution happens after the registrationperiod.',
    organizingRoles: 'Users with one of the selected roles can fully edit the event',
    oneWaitingListForEvent:
      'If this option is chosen, it is only possible to register for the event and not for groups in particular. Registered users will then be distributed randomly to the groups',
    dataProtectionCreatedAt: 'For privacy reasons, only your own enrollment time is shown',
    enrollTooEarly: 'The registrationperiod has not started yet.',
    maxParticipantsTooltip:
      'The maximum number cannot be reduced after the start of the registration period.',
    calendarInvite:
      'Depending on the prioritisation selected, the invitation will be sent either directly after registration or after the end of the registration period.'
  },
  sortOptions: {
    newest: 'Newest first',
    startDate: 'Starting soon',
    title: 'Eventname',
    host: 'Host'
  },
  alerts: {
    errorLoading: 'The event creation could not be loaded',
    failedCreate: 'The event could not be created',
    failedUpdate: 'The event could not be updated',
    failedAttachmentUpload: 'The attachment could not be uploaded',
    failedLoadEvent: 'The event could not be loaded',
    failedDelete: 'The event could not be deleted',
    failedCancel: 'The event could not be cancelled',
    failedGroupCancel: 'The group could not be cancelled',
    failedEnrollment:
      'You could not be registered for the event. The event or group is possibly full',
    failedEnrollmentForPreconditionFailed:
      'You could not be registered for the event. Possibly the event is already over or has been cancelled.',
    failedEnrollmentTooEarly:
      'You could not be registered for the event since the registrationperiod has not started yet.',
    failedUnenrollment: 'You could not be unregistered from the event',
    failedUnenroll: 'The unregister did not work',
    failedArticleCreation:
      'An event-article could not be created. One possible problem is that the duration of the event is less than 1 hour',
    successfulCreate: 'The event has been created',
    successfulUpdate: 'The event has been updated',
    successfulDelete: 'The event has been deleted',
    successfulCancel: 'The event has been cancelled',
    successfulGroupCancel: 'The group has been cancelled',
    successfulEnrollment: 'You registered for the event',
    successfulUnenrollment: 'You unregistered from the event',
    successfulEnrollmentToWaitingList:
      'You are now on the waitinglist because all slots all full right now',
    successfulEnrollmentToWaitingListForSemester:
      'You are now on the waitinglist, the distribution of participants for this event happens after the registrationperiod',
    successfulUnenrollmentFromWaitingList: 'You unregistered from the waitinglist.',
    successfulArticleCreation: 'You succesfully created an event-article.'
  },
  confirmationDialog: {
    deleteEventWarning: 'Do you really want to delete the event?',
    cancelEventWarning: 'Do you really want to cancel the event?',
    deleteEventInformation: 'The event is hereby irrevocably deleted.',
    cancelEventInformation:
      'The event is hereby irrevocably cancelled.\n All participants and people on the waitinglist will be informed via mail',
    enrollTitle: 'Please confirm you want to register for this event',
    enrollText: 'You can unregister from the event any time.',
    unenrollTitle: 'Please confirm you want to unregister from this event',
    unenrollText: 'You can register again at any time.',
    unenrollUserTitle: 'Please confirm you want to unregister the user from this event',
    unenrollUserText:
      'The user will receive a notification that he was unregistered from this event.',
    createArticleTitle: 'Articlecreation',
    createArticleText: 'Please confirm you want to create an article from this event.'
  },
  eventDetailPage: {
    backToListEventView: 'Back to the event overview',
    eventInformation: 'Event informations',
    registrationFrom: 'From',
    registrationUntil: 'Until',
    hostedBy: 'Hosted by',
    organizingAuthorgroups: 'Organizing authorgroups',
    organizingUsers: 'Organizing users',
    organizer: 'Organizer',
    enrollments: 'Enrollments',
    maxParticipants: 'Maximum number of participants',
    minParticipants: 'Minimum number of participants',
    actualNumberOfParticipants: 'Current number of participants',
    waitingListExists: 'Waiting list available',
    admissionCriteria: 'Participationinformations',
    groupOverview: 'Groupoverview',
    enrollmentOverviewSwitchToDesktopInfo:
      'To see the list of participants and waitinglist, please switch to the desktop view of the dashboard.',
    participatingEntitlements: 'Recipients',
    participatingSemesters: 'Participating Semesters',
    placement: 'Placement',
    timeOfEnrollment: 'Time of enrollment',
    waitingListTypes: {
      NONE: 'No Waitinglist',
      GROUP: 'Every group has its own waitinglist',
      EVENT: 'One waitinglist for the whole event'
    },
    priorizationType: {
      SEMESTER: 'Prioritize semester in descending order',
      DATE: 'Prioritize earliest registrations'
    },
    export: {
      exportSignature: 'Export signature list',
      exportEvent: 'Export the Event'
    },
    participantInfos: {
      status: 'Status',
      statusPreCalc: 'Status (provisionally)',
      position: 'Position',
      group: 'Group',
      participantStates: {
        waitingList: 'Waitinglist',
        participant: 'Enrolled'
      }
    },
    mail: {
      toParticipants: 'Send a mail to all participants',
      toPreCalcParticipants: 'Send a mail to all provisional participants',
      toWaitingList: 'Send a mail to all people on the waitinglist',
      toPreCalcWaitingList: 'Send a mail to all people on the provisional waitinglist'
    }
  }
};

export default en;
